import moment from 'moment';
import { store } from '@/store/store.js';

//Description: this file houses the functions the calculate the regular, ot, and travel time for a time card.

export function totalTime(times) {
  // let daysum = moment.duration();
  let daysum = 0;
  for (let t = 0; t <= times.length - 1; t++) {
    let start = moment(new Date(times[t].times[0]));
    let end = moment(new Date(times[t].times[1]));

    //remove miliseconds, so we don't end up with weird rounding
    start.milliseconds(0);
    end.milliseconds(0);

    // daysum.add(moment.duration(end.diff(start)));
    daysum += Number(
      roundToQuarter(Number(moment.duration(end.diff(start)).asHours()))
    );
  }

  // return roundToQuarter(daysum.asHours());
  return roundToQuarter(daysum);
}

export function regularTime(
  date,
  type,
  otIndex,
  index,
  lastRegTime,
  overRideValues,
  total,
  holidays
) {
  if (!Number.isNaN(overRideValues.regular)) {
    let stat = false;
    if (holidays.includes(moment(new Date(date)).format('YYYY-MM-DD'))) {
      stat = true;
    }

    if (type == 'employee') {
      if (stat) {
        return 0;
      } else if (otIndex == index) {
        return roundToQuarter(lastRegTime + overRideValues.otExempt);
      } else if (otIndex < index && otIndex != -1 && otIndex != null) {
        return overRideValues.otExempt;
      } else if (overRideValues.regular > 8) {
        return roundToQuarter(
          overRideValues.regular -
            (overRideValues.regular - 8) +
            overRideValues.otExempt
        );
      } else {
        return roundToQuarter(overRideValues.regular + overRideValues.otExempt);
      }
    } else if (type == 'driver') {
      //ot is at 10/50
      if (stat) {
        return 0;
      } else if (otIndex == index) {
        return roundToQuarter(lastRegTime + overRideValues.otExempt);
      } else if (otIndex < index && otIndex != -1 && otIndex != null) {
        return overRideValues.otExempt;
      } else if (overRideValues.regular > 10) {
        return roundToQuarter(
          overRideValues.regular -
            (overRideValues.regular - 10) +
            overRideValues.otExempt
        );
      } else {
        return roundToQuarter(overRideValues.regular + overRideValues.otExempt);
      }
    } else if (type == 'crusher crew') {
      //ot is at 10 hours a day, no weekly/shift total and travel doesn't count.
      if (stat) {
        return 0;
      } else if (overRideValues.regular > 10) {
        return roundToQuarter(
          overRideValues.regular -
            (overRideValues.regular - 10) +
            overRideValues.otExempt
        );
      } else {
        return roundToQuarter(overRideValues.regular + overRideValues.otExempt);
      }
    } else if (type == 'contractor') {
      return roundToQuarter(total - overRideValues.overtime);
    } else {
      return 'error';
    }
  }
  return 0;
}

export function otTime(
  date,
  type,
  otIndex,
  index,
  lastRegTime,
  overRideValues,
  total,
  holidays
) {
  let stat = false;
  if (holidays.includes(moment(new Date(date)).format('YYYY-MM-DD'))) {
    stat = true;
  }
  if (type == 'employee') {
    if (stat) {
      //we need to remove any on call time from this value here
      return total - overRideValues.onCall;
    } else if (otIndex == index) {
      //this is the day of the week that the ot total has been reached
      //add any time that is specified as overtime.
      //need to remove on call time
      return roundToQuarter(
        total - lastRegTime - overRideValues.onCall - overRideValues.otExempt
      );
    } else if (otIndex < index && otIndex != -1 && otIndex != null) {
      return roundToQuarter(
        total - overRideValues.onCall - overRideValues.otExempt
      );
    } else if (overRideValues.regular - 8 + overRideValues.overtime > 0) {
      //this if statement is to handle if there are overtime hours applied manually and there are under the daily maximum regular hours, so there are no daily ot hours.
      if (overRideValues.regular - 8 < 0) {
        return roundToQuarter(overRideValues.overtime);
      } else {
        return roundToQuarter(
          overRideValues.regular - 8 + overRideValues.overtime
        );
      }
    } else {
      return roundToQuarter(0 + overRideValues.overtime);
    }
  }
  if (type == 'driver') {
    if (stat) {
      return total;
    } else if (otIndex == index) {
      //add any time that is specified as overtime.

      return roundToQuarter(
        total - lastRegTime - overRideValues.onCall - overRideValues.otExempt
      );
    } else if (otIndex < index && otIndex != -1 && otIndex != null) {
      return roundToQuarter(
        total - overRideValues.onCall - overRideValues.otExempt
      );
    } else if (overRideValues.regular - 10 + overRideValues.overtime > 0) {
      //this if statement is to handle if there are overtime hours applied manually and there are under the daily maximum regular hours, so there are no daily ot hours.
      if (overRideValues.regular - 10 < 0) {
        return roundToQuarter(overRideValues.overtime);
      } else {
        return roundToQuarter(
          overRideValues.regular - 10 + overRideValues.overtime
        );
      }
    } else {
      return roundToQuarter(0 + overRideValues.overtime);
    }
  } else if (type == 'crusher crew') {
    if (stat) {
      return total;
    } else if (overRideValues.regular - 10 + overRideValues.overtime > 0) {
      //this if statement is to handle if there are overtime hours applied manually and there are under the daily maximum regular hours, so there are no daily ot hours.
      if (overRideValues.regular - 10 < 0) {
        return roundToQuarter(overRideValues.overtime);
      } else {
        return roundToQuarter(
          overRideValues.regular - 10 + overRideValues.overtime
        );
      }
    } else {
      return roundToQuarter(0 + overRideValues.overtime);
    }
  } else if (type == 'contractor') {
    return roundToQuarter(overRideValues.overtime);
  } else {
    return 'error';
  }
}

export function overRideValues(times, type) {
  //loop the times and get the different timespan times that are being utilized.
  let overtime = 0;
  let exemptTime = 0;
  let regularTime = 0;
  let travelTime = 0;
  let onCallTime = 0;
  let statExemptTime = 0;
  let statExemptDays = 0;
  let multipleTimeSpans = false;
  let otStatExempt = 0;
  let jobs = {};

  for (let i = 0; i <= times.length - 1; i++) {
    if (!jobs[`${times[i].job ? times[i].job : 'default'}`]) {
      jobs[`${times[i].job ? times[i].job : 'default'}`] = {
        overtime: 0,
        otExempt: 0,
        regular: 0,
        travel: 0,
        onCall: 0,
        statExemptTime: 0
      };
    }

    let startTime = moment(new Date(times[i].times[0]));
    let endTime = moment(new Date(times[i].times[1]));
    startTime.milliseconds(0);
    endTime.milliseconds(0);

    //the roundToQuarter function is rounding each timespan to two decimal places.
    let elapsedTime = Number(
      roundToQuarter(Number(moment.duration(endTime.diff(startTime)).asHours()))
    );

    if (times[i].type == 'overtime') {
      if (times[i].times[1] != undefined) {
        overtime += elapsedTime;
        jobs[
          `${times[i].job ? times[i].job : 'default'}`
        ].overtime += elapsedTime;
      }
    }

    if (times[i].type == 'ot exempt') {
      //if the time card is incomplete, just return 0.
      if (times[i].times[1] != undefined) {
        exemptTime += elapsedTime;
        if (store.state.statCountsOTExempt === 'No') {
          otStatExempt += elapsedTime;
          statExemptDays = 1;
        }
        jobs[
          `${times[i].job ? times[i].job : 'default'}`
        ].otExempt += elapsedTime;
      }
    }

    if (times[i].type == 'regular') {
      if (times[i].times[1] != undefined) {
        regularTime += elapsedTime;

        multipleTimeSpans = true;
        jobs[
          `${times[i].job ? times[i].job : 'default'}`
        ].regular += elapsedTime;
      }
    }

    if (times[i].type == 'travel time') {
      if (times[i].times[1] != undefined) {
        travelTime += elapsedTime;
        jobs[
          `${times[i].job ? times[i].job : 'default'}`
        ].travelTime += elapsedTime;
      }
    }

    if (times[i].type == 'on call') {
      if (times[i].times[1] != undefined) {
        onCallTime += elapsedTime;
        jobs[
          `${times[i].job ? times[i].job : 'default'}`
        ].onCall += elapsedTime;
      }
    }
    if (times[i].type === 'stat exempt') {
      if (times[i].times[1] != undefined) {
        statExemptDays = 1;

        if (type === 'contractor') {
          regularTime += elapsedTime;
          jobs[
            `${times[i].job ? times[i].job : 'default'}`
          ].regular += elapsedTime;
        }
        //Overtime is stat exempt already and does not need to be considered
        //this also accounts for if the stat exempt time span is what pushes the card into overtime
        else if (
          (regularTime >= 8 && type === 'employee') ||
          (regularTime >= 10 && (type === 'driver' || type === 'crusher crew'))
        ) {
          regularTime += elapsedTime;
          jobs[
            `${times[i].job ? times[i].job : 'default'}`
          ].regular += elapsedTime;
        } else if (regularTime + elapsedTime >= 8 && type === 'employee') {
          statExemptTime += 8 - regularTime;
          regularTime += elapsedTime;
          jobs[`${times[i].job ? times[i].job : 'default'}`].statExemptTime +=
            8 - elapsedTime;
          jobs[
            `${times[i].job ? times[i].job : 'default'}`
          ].regular += elapsedTime;
        } else if (
          regularTime + elapsedTime >= 10 &&
          (type === 'driver' || type === 'crusher crew')
        ) {
          statExemptTime += 10 - regularTime;
          regularTime += elapsedTime;
          jobs[`${times[i].job ? times[i].job : 'default'}`].statExemptTime +=
            10 - elapsedTime;
          jobs[
            `${times[i].job ? times[i].job : 'default'}`
          ].regular += elapsedTime;
        } else {
          statExemptTime += elapsedTime;
          regularTime += elapsedTime;
          jobs[
            `${times[i].job ? times[i].job : 'default'}`
          ].statExemptTime += elapsedTime;
          jobs[
            `${times[i].job ? times[i].job : 'default'}`
          ].regular += elapsedTime;
        }
      }
    }
  }
  //multiple time spans is set to true nly in regular time, which serves to tell us if there is any regular time on the time card, in which case we wouldn't increase stat exempt days

  if (multipleTimeSpans === true) {
    statExemptDays = 0;
  }

  return {
    overtime: overtime,
    otExempt: exemptTime,
    regular: regularTime,
    travel: travelTime,
    onCall: onCallTime,
    statExemptTime: statExemptTime,
    statExemptDays: statExemptDays,
    otStatExempt: otStatExempt,
    jobs: jobs
  };
}

export function parseTimeCards(tempArg, holidays) {
  let sum = 0;
  let index = -1;
  let lastHours = 0;
  let dayAdd = 0;
  for (let i = 0; i <= tempArg.length - 1; i++) {
    //itterate all of the times can get a total.
    let daysum = 0;
    for (let t = 0; t <= tempArg[i].times.length - 1; t++) {
      tempArg[i].times[t] = {
        times: [
          tempArg[i].times[t].startTime.toDate(),
          tempArg[i].times[t].endTime.toDate()
        ],
        type: tempArg[i].times[t].type,
        typeError: false,
        typeMessage: null,
        dateError: false,
        dateMessage: null
      };
      let start = moment(tempArg[i].times[t].times[0]);
      let end = moment(tempArg[i].times[t].times[1]);
      if (
        tempArg[i].times[t].type !== 'overtime' &&
        tempArg[i].times[t].type !== 'on call' &&
        tempArg[i].times[t].type !== 'ot exempt' &&
        !holidays.includes(
          moment(new Date(tempArg[i].date)).format('YYYY-MM-DD')
        )
      ) {
        //not sure if this will work. Let's see.
        daysum += moment.duration(end.diff(start)).asHours();
      }
    }
    if (tempArg[i].type == 'employee') {
      if (daysum >= 8) {
        sum += 8;
        dayAdd = 8;
      } else {
        sum += parseFloat(roundToQuarter(parseFloat(daysum)));
        dayAdd = parseFloat(roundToQuarter(parseFloat(daysum)));
      }

      if (sum >= 44 && index == -1) {
        //this algorithm was a thinker.
        //x = o-(s-c)
        //x = the regular time that is applied to reach the total of 44 hours worked in a work week.
        //o = the weekly ot maximum.
        //s = weekly sum
        //c = current day's regular hours that would be applied to the sum
        lastHours = 44 - (sum - dayAdd);
        index = i;
      }
    } else if (tempArg[i].type == 'driver') {
      if (daysum >= 10) {
        sum += 10;
        dayAdd = 10;
      } else {
        sum += parseFloat(roundToQuarter(parseFloat(daysum)));
        dayAdd = parseFloat(roundToQuarter(parseFloat(daysum)));
      }

      if (sum >= 50 && index == -1) {
        lastHours = 50 - (sum - dayAdd);
        index = i;
      }
    }
  }
  //this is the time card that will go over the weekly maximum
  return {
    lastRegTime: lastHours,
    otIndex: index,
    timeCardCollection: tempArg
  };
}

export function roundToQuarter(num) {
  if (store.getters.timeCardRounding == 'No') {
    return Math.round(num * 100) / 100;
    // return num.toFixed(2);
  } else if (store.getters.timeCardRounding == '1/4 Hour') {
    return (Math.round(num * 4) / 4).toFixed(2);
  } else if (store.getters.timeCardRounding == '1/2 Hour') {
    return (Math.round(num * 2) / 2).toFixed(2);
  }
}
